var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "h2 mb-2" }, [
        _vm._v(
          "\n            " + _vm._s(_vm.zoneRecoInternet.title) + "\n        "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "mt-2" }, [
        _c("div", { staticClass: "perso-reco row" }, [
          _c(
            "div",
            { staticClass: "col-6 col-md-3 mb-2 mb-md-1" },
            [
              _c(
                "ob1-cards",
                {
                  staticClass: "h-100",
                  attrs: { "with-composite-link": false },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.zoneRecoInternet.zoneRecoInternetItem1
                          .urlButton,
                        "data-oevent-category":
                          _vm.zoneRecoInternet.zoneRecoInternetItem1.tms
                            .tagZone,
                        "data-oevent-action": _vm.tagName(
                          _vm.zoneRecoInternet.zoneRecoInternetItem1.labelButton
                        ),
                        "data-oevent-label":
                          _vm.zoneRecoInternet.zoneRecoInternetItem1.urlButton,
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "w-100 card-img-top",
                        attrs: {
                          src: _vm.zoneRecoInternet.zoneRecoInternetItem1.image
                            .src,
                          alt: _vm.zoneRecoInternet.zoneRecoInternetItem1.image
                            .alt,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "p-0 p-md-1 text-center" },
                        [
                          _c("h3", {
                            staticClass: "card-title pb-1",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.zoneRecoInternet.zoneRecoInternetItem1.title
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("ob1-liens", {
                            staticClass: "mt-auto mw-100 d-none d-xl-block",
                            attrs: {
                              text: _vm.zoneRecoInternet.zoneRecoInternetItem1
                                .labelButton,
                              href: _vm.zoneRecoInternet.zoneRecoInternetItem1
                                .urlButton,
                              "with-arrow": true,
                              "data-oevent-category":
                                _vm.zoneRecoInternet.zoneRecoInternetItem1.tms
                                  .tagZone,
                              "data-oevent-action": _vm.tagName(
                                _vm.zoneRecoInternet.zoneRecoInternetItem1
                                  .labelButton
                              ),
                              "data-oevent-label":
                                _vm.zoneRecoInternet.zoneRecoInternetItem1
                                  .urlButton,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-6 col-md-3 mb-2 mb-md-1" },
            [
              _c(
                "ob1-cards",
                {
                  staticClass: "h-100",
                  attrs: { "with-composite-link": false },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.zoneRecoInternet.zoneRecoInternetItem2
                          .urlButton,
                        "data-oevent-category":
                          _vm.zoneRecoInternet.zoneRecoInternetItem2.tms
                            .tagZone,
                        "data-oevent-action": _vm.tagName(
                          _vm.zoneRecoInternet.zoneRecoInternetItem2.labelButton
                        ),
                        "data-oevent-label":
                          _vm.zoneRecoInternet.zoneRecoInternetItem2.urlButton,
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "w-100 card-img-top",
                        attrs: {
                          src: _vm.zoneRecoInternet.zoneRecoInternetItem2.image
                            .src,
                          alt: _vm.zoneRecoInternet.zoneRecoInternetItem2.image
                            .alt,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "p-0 p-md-1 text-center" },
                        [
                          _c("h3", {
                            staticClass: "card-title pb-1",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.zoneRecoInternet.zoneRecoInternetItem2.title
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("ob1-liens", {
                            staticClass: "mt-auto mw-100 d-none d-xl-block",
                            attrs: {
                              text: _vm.zoneRecoInternet.zoneRecoInternetItem2
                                .labelButton,
                              href: _vm.zoneRecoInternet.zoneRecoInternetItem2
                                .urlButton,
                              "with-arrow": true,
                              "data-oevent-category":
                                _vm.zoneRecoInternet.zoneRecoInternetItem2.tms
                                  .tagZone,
                              "data-oevent-action": _vm.tagName(
                                _vm.zoneRecoInternet.zoneRecoInternetItem2
                                  .labelButton
                              ),
                              "data-oevent-label":
                                _vm.zoneRecoInternet.zoneRecoInternetItem2
                                  .urlButton,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-6 mb-0 mb-md-1" }, [
            _c(
              "a",
              {
                staticClass:
                  "banner d-flex flex-column justify-content-center ps-1 ps-md-2 h-100",
                attrs: {
                  href: _vm.zoneRecoInternet.zoneRecoInternetItem3.url,
                  "data-oevent-category":
                    _vm.zoneRecoInternet.zoneRecoInternetItem3.tms.tagZone,
                  "data-oevent-action":
                    _vm.zoneRecoInternet.zoneRecoInternetItem3.tms.tagName,
                  "data-oevent-label":
                    _vm.zoneRecoInternet.zoneRecoInternetItem3.url,
                },
              },
              [
                _c("ob1-tag", {
                  staticClass: "ob1-tag-subscribed badge bg-white ps-2",
                  attrs: {
                    label: _vm.zoneRecoInternet.zoneRecoInternetItem3.tag,
                    type: "inverse",
                  },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "title text-white fw-bold m-0",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.zoneRecoInternet.zoneRecoInternetItem3.title
                    ),
                  },
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "banner-img h-100 w-100",
                  attrs: {
                    src: _vm.zoneRecoInternet.zoneRecoInternetItem3.image.src,
                    alt: _vm.zoneRecoInternet.zoneRecoInternetItem3.image.alt,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }